import {
  AtButtonProps,
  CSCFooterDrawer,
} from "@csc-dashboard/components-library";
import { useMemo } from "react";
import { useAdminPanel } from "../context/admin-panel";

export const BottomButton = () => {
  const { currentTab, togglePanel, setCurrentTab, isLoading } = useAdminPanel();

  const buttons: AtButtonProps[] = useMemo(() => {
    const closeDefault = {
      text: "Cerrar panel",
      onClick: togglePanel,
    };

    switch (currentTab) {
      case "client":
        return [closeDefault];
      case "folios":
        return [closeDefault];
      case "notes":
        return [
          {
            text: "Nueva nota",
            onClick: () => setCurrentTab("notes-form"),
            loading: isLoading,
          },
        ];
      default:
        return [closeDefault];
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [currentTab, togglePanel, setCurrentTab]);

  return (
    <CSCFooterDrawer
      mainButton={buttons[0] as AtButtonProps}
      secondaryButton={buttons[1]}
    />
  );
};
